import { StudioCard, type StudioCardEntity } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const studio: StudioCardEntity = {
  id: "1",
  name: "Calculus Lab",
  description:
    "Hands-on AI experiences for limits, derivatives, and integrals — worked examples, quick checks, and a tutor that meets you where you are.",
  customUrl: "calculus.aisquare.studio",
  followers: 1240,
  experiencesCount: 18,
  visibility: "public",
  owner: { name: "Ada Lovelace" },
  coCreators: [
    { name: "Carl Gauss", avatar: undefined },
    { name: "Emmy Noether", avatar: undefined },
  ],
};

const premium: StudioCardEntity = {
  ...studio,
  id: "2",
  name: "Quantum Studio",
  description: "Premium, subscriber-only experiences across the quantum stack.",
  customUrl: "quantum.aisquare.studio",
  visibility: "private",
  isPremium: true,
  followers: 8600,
  experiencesCount: 42,
};

export function StudioCardDemo() {
  return (
    <Section
      id="studio-card"
      title="StudioCard"
      description="Community-card-style studio tile. It composes the brand Card, so it inherits the Onyx hex-notch surface — the nx-s notch silhouette, the clip-safe elev-card drop-shadow (lifting on hover), and the continuous nx-rim keyline ring — without re-drawing any of it. The loading skeleton carries the same notch directly."
    >
      <VariantBlock label="Explore" caption='mode="explore" — subscribe CTA, notch surface inherited from Card'>
        <div className="w-[340px]">
          <StudioCard
            studio={studio}
            mode="explore"
            onPreview={() => {}}
            onFollowToggle={() => {}}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Manage" caption='mode="manage" — Manage CTA + actions dropdown'>
        <div className="w-[340px]">
          <StudioCard
            studio={studio}
            mode="manage"
            userCanManageStudio
            userCanDeleteStudio
            onPreview={() => {}}
            onManage={() => {}}
            onPromote={() => {}}
            onDelete={() => {}}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Glow halo" caption="glow — BorderGlow halo around the inherited notch surface (promoted / now-live treatment)">
        <div className="w-[340px]">
          <StudioCard
            studio={premium}
            mode="explore"
            hover="lift"
            glow
            isFollowing
            onPreview={() => {}}
            onFollowToggle={() => {}}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="List view" caption='view="list" — horizontal row, same notch surface'>
        <div className="w-[560px] max-w-full">
          <StudioCard studio={studio} view="list" mode="explore" onPreview={() => {}} />
        </div>
      </VariantBlock>

      <VariantBlock label="Skeleton" caption="StudioCard.Skeleton — same nx-s notch + clip-safe drop-shadow while loading">
        <div className="w-[340px]">
          <StudioCard.Skeleton />
        </div>
        <div className="w-[560px] max-w-full">
          <StudioCard.Skeleton view="list" />
        </div>
      </VariantBlock>
    </Section>
  );
}
